import { request } from "../helpers/axios.new";

export const ADD_WIDGETS_TO_LIST = (data) => {
  return request({
    url: `user-widgets`,
    method: "POST",
    data,
  });
};

// Pin one Analytics board to a player's "My Widgets" panel. The server
// checks that THAT player can already open the board, so an admin can't use
// this to hand out a dashboard nobody shared with them.
export const PIN_DASHBOARD_WIDGET = (data) => {
  return request({
    url: `user-widgets/dashboard`,
    method: "POST",
    data,
  });
};

// Choose which of a player's pinned boards show on the home page (at most
// two). Sets the whole choice in one call: the listed boards go on, every
// other pin of theirs comes off.
export const SET_HOME_DASHBOARDS = (data) => {
  return request({
    url: `user-widgets/dashboard/home`,
    method: "PUT",
    data,
  });
};

export const GET_WIDGETS_LIST = ({ userId, key, companyId }) => {
  return request({
    url: `user-widgets?userId=${userId}&key=${key}&companyId=${companyId}`,
    method: "GET",
  });
};

export const DELETE_WIDGET_FROM_LIST = (widgetId, userId) => {
  return request({
    url: `user-widgets?widgetId=${widgetId}&userId=${userId}`,
    method: "DELETE",
  });
};

export const TOGGLE_ON_WIDGET = (data) => {
  return request({
    url: `user-widgets/toggle-on`,
    method: "POST",
    data,
  });
};

export const TOGGLE_OFF_WIDGET = (widgetId, userId) => {
  return request({
    url: `user-widgets/toggle-off?widgetId=${widgetId}&userId=${userId}`,
    method: "DELETE",
  });
};
